module.exports = __webpack_public_path__ + "static/media/EDUCalender-dark.cdbf66e5.png";